export interface ThresholdsFormProfileSnapshot {
  alertHigh: string;
  alertLow: string;
  warnHigh: string;
  warnLow: string;
  active: boolean;
}

export const ThresholdsFormDefaultValuesSnapshot: ThresholdsFormProfileSnapshot = {
  alertHigh: '',
  alertLow: '',
  warnHigh: '',
  warnLow: '',
  active: false,
};

export const ThresholdsFormErrorTypesSnapshot = {
  limits: 'limitsError',
};
